import React from 'react';

import { MenuEntry } from '@europrocurement/flexy-components';

import {
    KeycloakRoute,
    REALM_ADMIN,
    REALM_COMPTA,
    REALM_MADA,
} from '@europrocurement/l2d-keycloak';
import {
    doneInvoiceIcon,
    invoiceIcon,
    myInvoiceIcon,
    pausedInvoiceIcon,
    pausedStatementIcon,
    rejectCodesList,
    rejectCodesOnInvoicesIcon,
    statsOnInvoicesIcon,
    todoInvoiceIcon,
} from '@europrocurement/l2d-icons';
import MediaObjectImportView from './views/imports/MediaObjectImportView';
import RegisterSimpleInvoiceView from './views/forms/simple/RegisterSimpleInvoiceView';
import UpdateSimpleInvoiceView from './views/forms/simple/UpdateSimpleInvoiceView';

import AchatsRoot from './AchatsRoot';
import StatsView from './views/stats/StatsView';
import RegisteredInvoicesView from './views/lists/RegisteredInvoicesView';
import RegisterMultiInvoiceView from './views/forms/multi/RegisterMultiInvoiceView';
import { EnteteSaisieMultiple } from './components/forms/multi/steps/EnteteSaisieMultiple';
import { DossierSaisieMultiple } from './components/forms/multi/steps/DossierSaisieMultiple';
import { RecapSaisieMultiple } from './components/forms/multi/steps/RecapSaisieMultiple';
import { NextDossierSaisieMultiple } from './components/forms/multi/steps/NextDossierSaisieMultiple';
import UnclosedRegisteredInvoicesView from './views/lists/UnclosedRegisteredInvoicesView';
import { NextEditDossierSaisieMultiple } from './components/forms/multi/steps/NextEditDossierSaisieMultiple';
import {
    achatsBasePath,
    consulterMultiFacturePath,
    downloadPath,
    invoiceStatementPath,
    listePath,
    modifierFacturePath,
    nextDossierMultiFacturePath,
    nextEditDossierMultiFacturePath,
    nextEditFproDossierMultiFacturePath,
    pausePath,
    recapFproMultiFacturePath,
    recapMultiFacturePath,
    summaryStatementPath,
    registerStatementPath,
    saisirDossierMultiFacturePath,
    saisirEditDossierMultiFacturePath,
    saisirEditFproDossierMultiFacturePath,
    saisirEnteteMultiFacturePath,
    saisirEnteteMultiFactureStatementPath,
    saisirFacturePath,
    saisirMultiFacturePath,
    statsPath,
    traitePath,
    uploadPath,
    readUnclosedStatementPath,
    internMediaObjectsPath,
    updateStatementPath,
    rejectCodesPath,
} from './constants/paths';
import achatsViewPathResolver from './achatsViewPathResolver';
import UnregisteredInvoicesView from './views/lists/UnregisteredInvoicesViews/UnregisteredInvoicesView';
import { RecapFproSaisieMultiple } from './components/forms/multi/steps/RecapFproSaisieMultiple';
import UnclosedInvoiceStatementsView from './views/lists/UnclosedInvoiceStatementsView';
import ReadStatementView from './views/forms/statement/ReadStatementView';
import SummaryStatementView from './views/forms/statement/SummaryStatementView';
import InternUnregisteredInvoicesView from './views/lists/InternUnregisteredInvoicesView';
import UpdateMultiInvoiceView from './views/forms/multi/UpdateMultiInvoiceView';
import UpdateMultiPublicationForm from './components/forms/multi/UpdateMultiPublicationForm';
import UpdateMultiFormalityForm from './components/forms/multi/UpdateMultiFormalityForm';
import RejectCodesList from './views/lists/RejectCodesList';
import RejectCodeDetail from './views/detail/RejectCodeDetail';
import RejectCodeRoot from './subroots/RejectCodeRoot';

const VALID_ROLES = [REALM_ADMIN, REALM_COMPTA];
const VALID_ROLES_MADA = [REALM_MADA];

export const AchatsRouter = {
    path: achatsBasePath,
    element: <AchatsRoot />,
    handle: { title: 'Achats' },
    children: [
        {
            path: listePath,
            children: [
                // La liste des factures a traiter
                {
                    path: '',
                    index: true,
                    element: (
                        <KeycloakRoute roles={[...VALID_ROLES, ...VALID_ROLES_MADA]}>
                            <UnregisteredInvoicesView />
                        </KeycloakRoute>
                    ),
                    handle: { title: 'Achats - Liste des factures à traiter' },
                },
                // La liste des factures a traiter en interne
                {
                    path: internMediaObjectsPath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <InternUnregisteredInvoicesView />
                        </KeycloakRoute>
                    ),
                    handle: { title: 'Achats - Liste des factures à traiter en interne' },
                },
                // Vue de la liste des relevés de facture non clôturé
                {
                    path: invoiceStatementPath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={[...VALID_ROLES, ...VALID_ROLES_MADA]}>
                            <UnclosedInvoiceStatementsView />
                        </KeycloakRoute>
                    ),
                    handle: { title: 'Achats - Liste des relevés de facture non clôturé' },
                },
                // Télécharge le fichier PDF
                {
                    path: downloadPath,
                    index: true,
                    element: (
                        <>
                            <br />
                            **Téléchargement du PDF... ** <br />
                            <br /> la page doit se fermée directement et laisser le navigateur web
                            gérer le téléchargement.
                        </>
                    ),
                    handle: { title: 'Achats - Téléchargement du PDF...' },
                },
                // Saisie d'une nouvelle facture liée à un PDF
                {
                    path: saisirFacturePath,
                    index: true,
                    element: <RegisterSimpleInvoiceView />,
                    handle: { title: "Achats - Saisie d'une nouvelle facture" },
                },
                // Saisie d'une nouvelle facture multi-annonces liée à un PDF
                {
                    path: saisirMultiFacturePath,
                    abstract: true,
                    // index: true,
                    element: <RegisterMultiInvoiceView />,
                    children: [
                        {
                            path: saisirEnteteMultiFactureStatementPath,
                            index: true,
                            element: <EnteteSaisieMultiple />,
                        },
                        {
                            path: saisirEnteteMultiFacturePath,
                            index: true,
                            element: <EnteteSaisieMultiple />,
                        },
                        {
                            path: saisirDossierMultiFacturePath,
                            element: <DossierSaisieMultiple />,
                        },
                        {
                            path: nextDossierMultiFacturePath,
                            element: <NextDossierSaisieMultiple />,
                        },
                        {
                            path: saisirEditDossierMultiFacturePath,
                            element: <UpdateMultiPublicationForm />,
                        },
                        {
                            path: saisirEditFproDossierMultiFacturePath,
                            element: <UpdateMultiFormalityForm />,
                        },
                        {
                            path: nextEditDossierMultiFacturePath,
                            element: <NextEditDossierSaisieMultiple />,
                        },
                        {
                            path: nextEditFproDossierMultiFacturePath,
                            element: <NextEditDossierSaisieMultiple isFormalite />,
                        },
                        {
                            path: recapMultiFacturePath,
                            element: <RecapSaisieMultiple />,
                            handle: {
                                title: 'Achats - Récapitulatif facture multi-dossiers',
                            },
                        },
                        {
                            path: recapFproMultiFacturePath,
                            element: <RecapFproSaisieMultiple />,
                            handle: {
                                title: 'Achats - Récapitulatif facture multi-dossiers formalités',
                            },
                        },
                    ],
                },
                // Modification
                {
                    path: modifierFacturePath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <UpdateSimpleInvoiceView />
                        </KeycloakRoute>
                    ),
                    handle: { title: 'Achats - Édition facture simple' },
                },
                {
                    path: consulterMultiFacturePath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <UpdateMultiInvoiceView />
                        </KeycloakRoute>
                    ),
                    handle: { title: 'Achats - Récapitulatif facture multi-dossiers' },
                },
                // La liste des factures traitées
                {
                    path: traitePath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <RegisteredInvoicesView />
                        </KeycloakRoute>
                    ),
                    handle: { title: 'Achats - Liste des factures traitées' },
                },
                // La liste des factures en pause
                {
                    path: pausePath,
                    index: true,
                    element: <UnclosedRegisteredInvoicesView />,
                    handle: { title: 'Achats - Liste des factures en pause' },
                },
                {
                    element: <RejectCodeRoot />,
                    children: [
                        {
                            path: rejectCodesPath,
                            children: [
                                {
                                    path: '',
                                    index: true,
                                    element: (
                                        <KeycloakRoute roles={VALID_ROLES}>
                                            <RejectCodesList />
                                        </KeycloakRoute>
                                    ),
                                    handle: { title: 'Achats - Liste des codes rejets' },
                                },
                                {
                                    path: ':idRejectCode',
                                    element: (
                                        <KeycloakRoute roles={VALID_ROLES}>
                                            <RejectCodeDetail />
                                        </KeycloakRoute>
                                    ),
                                    handle: { title: 'Achats - Détail code rejet' },
                                },
                            ],
                        },
                    ],
                    handle: { title: 'Achats - Codes rejets' },
                },
            ],
        },
        // Saisie d'une nouvelle facture liée à un PDF et un relevé
        {
            path: registerStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={[...VALID_ROLES, ...VALID_ROLES_MADA]}>
                    <RegisterSimpleInvoiceView />
                </KeycloakRoute>
            ),
            handle: { title: "Achats - Saisie d'une nouvelle facture liée à un relevé" },
        },
        // Édition d'une facture liée à un PDF et un relevé
        {
            path: updateStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={[...VALID_ROLES, ...VALID_ROLES_MADA]}>
                    <UpdateSimpleInvoiceView />
                </KeycloakRoute>
            ),
            handle: { title: "Achats - Édition d'une facture liée à un relevé" },
        },
        // Consultation d'un relevé de factures
        {
            path: readUnclosedStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={[...VALID_ROLES, ...VALID_ROLES_MADA]}>
                    <ReadStatementView />
                </KeycloakRoute>
            ),
            handle: { title: "Achats - Consultation d'un relevé de factures" },
        },
        // Recap des factures d'un relevé
        {
            path: summaryStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={[...VALID_ROLES, ...VALID_ROLES_MADA]}>
                    <SummaryStatementView />
                </KeycloakRoute>
            ),
            handle: { title: "Achats - Récapitulatif des factures d'un relevé" },
        },
        {
            path: uploadPath,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <MediaObjectImportView />
                </KeycloakRoute>
            ),
            handle: { title: 'Achats - Ajout manuel de facture' },
        },
        {
            path: statsPath,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <StatsView />
                </KeycloakRoute>
            ),
            handle: { title: 'Codes rejets - Statistiques' },
        },
    ],
};

export const AchatsMenuEntries: MenuEntry[] = [
    {
        title: 'Portail Achats',
        role: [...VALID_ROLES, ...VALID_ROLES_MADA],
        icon: 'file-invoice-dollar',
        children: [
            {
                title: 'Import',
                icon: 'file-import',
                href: achatsViewPathResolver('uploadMediaObject'),
                role: VALID_ROLES,
            },
            {
                title: 'Factures',
                icon: invoiceIcon,
                role: [...VALID_ROLES, ...VALID_ROLES_MADA],
                children: [
                    {
                        title: 'À traiter',
                        icon: todoInvoiceIcon,
                        href: achatsViewPathResolver('listmediaobject'),
                        role: [...VALID_ROLES, ...VALID_ROLES_MADA],
                    },
                    {
                        title: 'À traiter en interne',
                        icon: myInvoiceIcon,
                        href: achatsViewPathResolver('listmediaobjectinternally'),
                        role: VALID_ROLES,
                    },
                    {
                        title: 'Traitées',
                        icon: doneInvoiceIcon,
                        role: VALID_ROLES,
                        href: achatsViewPathResolver('listfacture'),
                    },
                    {
                        title: 'En pause',
                        icon: pausedInvoiceIcon,
                        href: achatsViewPathResolver('listfacturepause'),
                        role: [...VALID_ROLES, ...VALID_ROLES_MADA],
                    },
                    {
                        title: 'Relevés non clôturés',
                        icon: pausedStatementIcon,
                        href: achatsViewPathResolver('listInvoiceStatement'),
                        role: [...VALID_ROLES, ...VALID_ROLES_MADA],
                    },
                ],
            },
            {
                title: 'Codes Rejets',
                icon: rejectCodesOnInvoicesIcon,
                role: VALID_ROLES,
                children: [
                    {
                        title: 'Gestion des erreurs',
                        icon: statsOnInvoicesIcon,
                        href: achatsViewPathResolver('achatsstats'),
                        role: VALID_ROLES,
                    },
                    {
                        title: 'Configuration des codes rejets',
                        icon: rejectCodesList,
                        href: achatsViewPathResolver('listRejectCodes'),
                        role: VALID_ROLES,
                    },
                ],
            },
        ],
    },
];
